<template>
  <div id="app">
    
    <section class="jumbotron jumbotron-fluid text-center p-3" style="background-image: radial-gradient( circle 779px at 2.6% 5.8%,  rgba(5,169,230,1) 13.5%, rgba(62,236,214,1) 90.4% );background-image: radial-gradient( circle 592px at 48.2% 50%,  rgba(255,255,249,0.6) 0%, rgba(160,199,254,1) 74.6% );background-image: linear-gradient( 109.6deg,  rgba(75,153,245,1) 11.3%, rgba(177,226,254,1) 100.2% );background-image: radial-gradient( circle farthest-corner at 10% 20%,  rgba(69,86,102,1) 0%, rgba(34,34,34,1) 90% );">
      <div class="row justify-content-end text-right">
        <div class="col-sm">
          <div class="pull-right dropdowns-col hidden-sm">
            <div class="btn-group">
              <button class="btn btn-default btn-xs dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ selected_currency }}
              </button>
              <div class="dropdown-menu dropdown-menu-right" style="min-width:inherit" aria-labelledby="dropdownMenuButton">
                <a href="#" class="dropdown-item" @click="selected_currency = 'USD'">USD</a>
                <a href="#" class="dropdown-item" @click="selected_currency = 'EUR'">EUR</a>
                <a href="#" class="dropdown-item" @click="selected_currency = 'BTC'">BTC</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <h1 class="jumbotron-heading text-light">
          <i class="fab fa-bitcoin"></i> Crypto Table
        </h1>
        <p class="lead text-muted">A Periodic Table of Cryptocurrencies</p>
      </div>
    </section>

    <div class="album">
      <div class="container">
        <div class="wrapper">
          <ul class="main">
            <template v-for="(row, row_idx) in crypto_table">
              <template v-for="(crypto, index) in row">
                <Block v-bind:key="row_idx + '.' + index" v-bind:crypto="crypto" v-bind:currentClass="current_class" v-bind:currency="selected_currency"
                  @mouseover.native="onMouseOver" @mouseout.native="onMouseOut"></Block>
              </template>
            </template>        
          </ul>
          
          <div class="legend pb-0">
            <ul class="list-2">
              <li title="Currencies with features to make transactions anonymous and/or untraceable." class="type-2" @mouseover="onMouseOver" @mouseout="onMouseOut">Privacy Coins</li>
              <li title="Coins used primarily for payments and to store value." class="type-3" @mouseover="onMouseOver" @mouseout="onMouseOut">Payments / Currency</li>
              <li title="Smart contract and decentralized application (dapp) platforms." class="type-4" @mouseover="onMouseOver" @mouseout="onMouseOut">Platforms</li>
              <li title="Projects related to the gaming industry, online content publishing and distribution, and social media." class="type-5" @mouseover="onMouseOver" @mouseout="onMouseOut">Gaming, Media & Social</li>
              <li title="Projects related to computing, data storage and security, and cloud services including file storage and cloud computing." class="type-7" @mouseover="onMouseOver" @mouseout="onMouseOut">Computing & Cloud Services</li>
              <li title="Projects building decentralized infrastructure to exchange cryptocurrencies and enable communication between different blockchains." class="type-8" @mouseover="onMouseOver" @mouseout="onMouseOut">Protocols, Exchanges & Interop</li>
              <li title="Financial services and technology." class="type-9" @mouseover="onMouseOver" @mouseout="onMouseOut">FinTech</li>
              <li title="Assets that have price stability which make it suitable for short-term and medium-term use as a unit of account and store of value, often pegged to a national currency." class="type-11" @mouseover="onMouseOver" @mouseout="onMouseOut">Stable Coins</li>
              <li title="Platforms meant to help businesses improve efficiency, transparency, and security, among other things." class="type-10" @mouseover="onMouseOver" @mouseout="onMouseOut">Business & Enterprise</li>
              <li title="Projects that didn’t fit into any of the other categories. These include prediction markets, oracles, betting platforms, and AI-related projects." class="type-6" @mouseover="onMouseOver" @mouseout="onMouseOut">Others</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <footer class="jumbotron jumbotron-fluid" style="margin-bottom:0px">
      <div class="container">
        <p class="float-right">
          <a href="#">Back to top</a>
        </p>
        <p class="text-muted">Built by <a href="https://jes.al" target="_blank">Jesal Gadhia</a>. Tweet me your feedback / suggestions <a href="https://twitter.com/jesalg" target="_blank">@jesalg</a></p>
        <p class="text-muted">Inspired by <a href="https://www.investinblockchain.com/periodic-table-cryptocurrencies/" target="_blank">this blog post</a>. Data provided by <a href="https://www.cryptocompare.com/" target="_blank">CryptoCompare</a> API. </p>
      </div>
    </footer>
  </div>
</template>

<script>
import Block from './components/Block.vue'
import data from './assets/data.json'
import tippy from 'tippy.js'

import 'bootstrap';
//import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/bootstrap4-charming.css'
import './assets/bootstrap4-flat.css'

export default {
  name: 'app',
  data() {
    return {
      crypto_table: data,
      current_class: null,
      selected_currency: 'USD'
    }
  },
  components: {
    Block
  },
  mounted() {
    tippy('.list-2 li', {theme: 'custom'})
  },
  methods: {
    onMouseOver(e) {
      if (e.target && e.target.className) {
        const cssClass = e.target.className.split(' ')[0]
        if (cssClass != 'empty') {
          this.current_class = cssClass
        }
      } else if (e.fromElement && e.fromElement.className) {
        this.current_class = e.fromElement.className.split(' ')[0]
      } else if (e.target && e.target.offsetParent) {
        this.current_class = e.target.offsetParent.className.split(' ')[0]
      }
    },
    onMouseOut() {
      this.current_class = null
    }
  }
}
</script>

<style>
* { box-sizing: border-box; padding:0; margin:0; }

.wrapper {
  width:1050px;
  margin:30px auto;
  position:relative;
} 

.main:after {
  clear:both;
  content:"";
  display:table;
}
 
.main li {
  width:56px;
  height:60px;
  position:relative;
  font-size:15px;
  float:left;
  padding:0 2px;
  margin:1px;
  cursor:pointer;
  padding-top:15px;
  overflow:hidden;
  transition:all .2s ease-in;
}

.main li span {
  display:block;
  line-height:1;
  font-size:9px;
  color:#333; 
  padding-top:4px;
  position: absolute;
  bottom: 2px; 
}

.main li a {
  text-decoration: none;
  color: inherit
}

.main .empty {
  border:none; 
  box-shadow:none;
  cursor:default;
}

.deactivate {
  opacity:0.3;
  -webkit-filter:grayscale(70%);
  filter:grayscale(70%);
}

.main li:before,
.main li:after {
  content:attr(data-pos);
  position:absolute;
  top:3px;
  left:3px;
  color:#333;
  font-size:8px;
  line-height:1;
}

.main li:after {
  content:attr(data-nb);
  left:auto;
  right:3px;
}

.main li:hover {
  transform:scale(2);
  z-index:100;
  box-shadow: 0 0 10px rgba(0,0,0,0.3);
} 

.main .empty:hover {
  box-shadow:none;
  transform:none;
}

.type-0 { background:#fff; }
.type-1 { background:#FFD447; }
.type-2 { background:#EF8354; }
.type-3 { background:#B2DBBF; }
.type-4 { background:#FDD5B2; }
.type-5 { background:#4ECDC4; }
.type-6 { background:#E8C2CA; }
.type-7 { background:#5BC0EB; }
.type-8 { background:#9FB1BC; }
.type-9 { background:#A5BE00; }
.type-10 { background:#D3D0CB; }
.type-11 { background:#E6B89C; }

.legend {
  margin-bottom: 0px !important;
  position:absolute;
  top:-2%;
  left:24%;
  padding:10px;
  font-size:13px;
}

.legend:after {
   content:"";
  display:table;
  clear:table;
}

.legend ul { float:left; list-style: none; }

.legend .list-2 {
  width:400px;
}

.legend .list-2 li {
  margin:2px;
  padding:3px;
  float:left; 
  border:1px dashed rgba(0,0,0,0.2);
  width:40%;
  cursor:pointer;
}

.tippy-tooltip.custom-theme .tippy-backdrop {
  background-image: radial-gradient( circle 779px at 2.6% 5.8%,  rgba(5,169,230,1) 13.5%, rgba(62,236,214,1) 90.4% );background-image: radial-gradient( circle 592px at 48.2% 50%,  rgba(255,255,249,0.6) 0%, rgba(160,199,254,1) 74.6% );background-image: linear-gradient( 109.6deg,  rgba(75,153,245,1) 11.3%, rgba(177,226,254,1) 100.2% );background-image: radial-gradient( circle farthest-corner at 10% 20%,  rgba(69,86,102,1) 0%, rgba(34,34,34,1) 90% );
}
</style>
